export const HOME_PATH = '/home'

export function THEME_PATH(theme = ':theme') {
    return `/theme/${theme}`
}

export function COURSE_PATH(theme = ':theme', id = ':id') {
    return `/course/${theme}/${id}`
}

export function COVER_PATH(theme = ':theme') {
    return `/cover/${theme}?`
}

export function GRAPHIC_PATH(theme = ':theme') {
    return `/graphic/${theme}?`
}

// 通用列表页面
export function GENERALLIST_PATH(theme = ':theme') {
    return `/generalList/${theme}?`
}

// 通用分类页面
export function CLASSIFYLIST_PATH(theme = ':theme') {
    return `/classifyList/${theme}?`
}